module.exports = __webpack_public_path__ + "img/coupon_zh.9449e880.png";